/**
 * Formats a date to a readable format.
 * Example: "5/15/2023, 2:30 PM"
 */
export const formatDate = (date: Date): string => {
  try {
    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
      console.warn('Invalid date in formatDate:', date);
      return 'Invalid date';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error in formatDate:', error);
    return 'Error formatting date';
  }
};

/**
 * Formats a time to 12-hour format without seconds.
 * Example: "2:30 PM"
 */
export const formatTime = (date: Date): string => {
  try {
    // Verificar si la fecha es válida
    if (isNaN(date.getTime())) {
      console.warn('Invalid date in formatTime:', date);
      return 'Invalid time';
    }

    return date.toLocaleString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  } catch (error) {
    console.error('Error in formatTime:', error);
    return 'Error formatting time';
  }
};

/**
 * Formatea una fecha a ISO string con el formato específico requerido
 * Ejemplo: "2025-05-09T16:00:00"
 */
export const formatISODate = (date: Date): string => {
  try {
    // Formatear manualmente para obtener el formato exacto YYYY-MM-DDTHH:mm:ss
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  } catch (error) {
    console.error('Error formatting ISO date:', error);
    return '';
  }
};

/**
 * Rangos de fechas para filtros
 */
export const getDateRanges = () => {
  const now = new Date();
  
  // Hoy: Desde las 00:00:00 hasta las 23:59:59 del día actual
  const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const todayEnd = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
  
  // Últimos 7 días: Desde hace 7 días a las 00:00:00 hasta ahora
  const lastWeekStart = new Date(now);
  lastWeekStart.setDate(now.getDate() - 7);
  lastWeekStart.setHours(0, 0, 0, 0);
  
  // Mes actual: Desde el día 1 del mes actual a las 00:00:00 hasta ahora
  const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0);
  
  // Year-to-Date (YTD): Desde el 1 de enero del año actual a las 00:00:00 hasta ahora
  const ytdStart = new Date(now.getFullYear(), 0, 1, 0, 0, 0);
  
  return {
    today: {
      start: formatISODate(todayStart),
      end: formatISODate(todayEnd)
    },
    lastWeek: {
      start: formatISODate(lastWeekStart),
      end: formatISODate(now)
    },
    thisMonth: {
      start: formatISODate(thisMonthStart),
      end: formatISODate(now)
    },
    ytd: {
      start: formatISODate(ytdStart),
      end: formatISODate(now)
    }
  };
};
